import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory from '../modelFactory';
import workAreaModel, { IProposalWorkArea } from './proposalWorkAreaModel';

export interface IProposal {
	accountManagerKey?: string;
	date?: string;
	recpient?: any;
	estimatedPrice?: any;
	includedItems: string[];
	excludedItems: string[];
	terms?: string;
	workAreas: IProposalWorkArea[];
	createWorkArea(data: Record<string, any>): IProposalWorkArea;
}

const proposalFactory = modelFactory.createFactory<IProposal>('Proposal', {
	accountManagerKey: {
		setFilters: valueFilters.clean
	},
	date: {
		setFilters: valueFilters.clean
	},
	recipient: {
	},
	estimatedPrice: {
	},
	includedItems: {
		defaultValue: []
	},
	excludedItems: {
		defaultValue: []
	},
	terms: {
	},
	workAreas: {
		setFilters: valueFilters.toModelSet(workAreaModel),
		rules: validator.validModel(workAreaModel.rules()),
		defaultValue: []
	},
	createWorkArea: function (data) {
		const rootName = data.name && data.name.replace(/\s\d+$/, '');
		let nameSuffix = 1;
		let newName = rootName;

		// ensure unique work area name
		if (rootName) {
			while (_.find(this.workAreas, area => area.name.toLowerCase() === newName.toLowerCase())) { //eslint-disable-line  no-loop-func
				newName = `${rootName} ${nameSuffix++}`;
			}

			data.name = newName;
		}

		const sortIndex = _.reduce(this.workAreas, (max, w) => w.sortIndex >= max ? w.sortIndex + 1 : max, 0);

		return workAreaModel(_.assign(data, { sortIndex }));
	}
});

export default proposalFactory;